export enum enumPaymentType {
    esp = 'Espèces',
    mobilMoney = 'Paiement Mobile',
    cb = 'Carte Bancaire',
    cheque = 'Chèque',
    credit = 'Crédit',
}